import createIcon from '../../createIcon';

/**
 * @component @name LocalCafe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0gzVjEzQzMgMTUuMjEgNC43OSAxNyA3IDE3SDEzQzE1LjIxIDE3IDE3IDE1LjIxIDE3IDEzVjEwSDE5QzIwLjExIDEwIDIxIDkuMSAyMSA4VjVDMjEgMy44OSAyMC4xMSAzIDE5IDNaTTE5IDhIMTdWNUgxOVY4Wk0zIDE5SDE5VjIxSDNWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalCafe = createIcon('LocalCafe', [
  [
    'path',
    {
      d: 'M19 3H3V13C3 15.21 4.79 17 7 17H13C15.21 17 17 15.21 17 13V10H19C20.11 10 21 9.1 21 8V5C21 3.89 20.11 3 19 3ZM19 8H17V5H19V8ZM3 19H19V21H3V19Z',
      key: '1ce7j4',
    },
  ],
]);

export default LocalCafe;
